<template>
  <div class="subscription-management pb-5">
    <div v-if="isSubscribed && !(isWebSubscription || isHotmartSubscription)">
      <v-row class="mx-2 mx-sm-10 mt-5">
        <v-col>
          <div class="box pa-4 d-flex rounded ma-auto" style="max-width: 360px">
            <iconInfo class="flex-shrink-0 mr-3"/>
            <div class="text" v-if="isIosSubscripton">{{ $t('settings.management.currentIsIos') }}</div>
            <div class="text" v-else>{{ $t('settings.management.currentIsAndroid') }}</div>
          </div>

          <div class="text text-center mt-5 mb-5">{{ $t('settings.management.currentCanManage') }}</div>

          <div class="instruction d-block d-sm-flex ma-auto justify-space-between" :class="{ ios: isIosSubscripton }">
            <div class="step-1 text-center">
              <div class="screenshot"></div>
              <div class="text mt-3">1. {{ isIosSubscripton ? $t('settings.management.step1Ios') : $t('settings.management.step1Android') }}</div>
            </div>
            <iconNext class="next"/>
            <div class="step-2 text-center">
              <div class="screenshot"></div>
              <div class="text mt-3">2. {{ $t('settings.management.step2') }}</div>
            </div>
            <iconNext class="next" />
            <div class="step-3 text-center">
              <div class="screenshot"></div>
              <div class="text mt-3">3. {{ $t('settings.management.step3') }}</div>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>

    <div v-if="isSubscribed && (isWebSubscription || isHotmartSubscription) && isCanceled && !isSpecial">
      <v-row class="mx-2 mx-sm-10 mt-5">
        <v-col>
          <div class="subscription pa-7 d-flex flex-column justify-center align-center rounded">
            <!-- <iconLogoPlus width="220" /> -->
            <div>Subscribed</div>
            <div class="text-canceled mt-5 mb-4 text-center">{{ $t('settings.management.expireOn') }} {{ endDate }}  </div>
            <loaderButton
                component="v-btn"
                class="primary btn-text px-10 py-7"
                dark
                @click.stop.prevent="restore"
                :loading="restoreLoading"
            >
              {{ $t('settings.management.reactive') }}
            </loaderButton>
          </div>
        </v-col>
      </v-row>
    </div>

    <div v-if="!isSubscribed">
      <v-row class="mx-2 mx-sm-10 mt-5 d-block d-sm-flex align-start">
        <v-col cols="3" class="label d-flex align-center justify-center justify-sm-end mb-n3 mb-sm-0 mt-sm-4">
          {{ $t('settings.management.currentPlan') }}
        </v-col>
        <v-col>
          <div class="box">
            <div class="pa-4 d-flex text-center justify-space-between align-center ">
              <div class="text">
                Free Plan
              </div>
              <div class="action" @click="goToSubscribe">{{ $t('settings.management.upgrade') }}</div>
            </div>
            <div class="subscription pa-7 d-block justify-space-between align-center rounded text-center">
              <!-- <iconLogoPlus width="158" /> -->
              <div>Subscribed</div>
              <div class="pluses mx-auto mt-3 mb-4 mt-sm-5 mb-sm-6 text-center text-sm-left">
                <div class="plus">
                  • {{ $t('settings.management.pluses[0]') }}
                </div>
                <div class="plus">
                  • {{ $t('settings.management.pluses[1]') }}
                </div>
                <div class="plus">
                  • {{ $t('settings.management.pluses[2]') }}
                </div>
              </div>
              <v-btn class="start-trial primary btn-text px-7" dark @click="goToSubscribe">{{ $t('base.startTrial') }}</v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>

    <div v-if="is3xLifetime || (isSubscribed && (isWebSubscription || isHotmartSubscription) && (isSpecial || !isCanceled))">
      <v-row class="mx-2 mx-sm-10 mt-5 d-block d-sm-flex">
        <v-col cols="3" class="label d-flex align-center justify-center justify-sm-end mb-n3 mb-sm-0">
          {{ $t(!isSubscribed && is3xLifetime ? 'settings.management.prevPlan' : 'settings.management.currentPlan') }}
        </v-col>
        <v-col>
          <div class="subscription pa-7 d-block d-sm-flex justify-space-between align-center rounded text-center">
            <!-- <iconLogoPlus width="158" /> -->
            <div>Subscribed</div>
            <div v-if="isSpecial" class="d-flex align-center">
                {{ $t('onboardingSpecial.information.left.lifetimeOwnership') }}
                <span v-if="is3xLifetime" class="transactions d-flex ml-3">
                  <v-tooltip top  v-for="i in [0,1,2]" :key="i" :value="!isSubscribed && transactions[i - 1]" :disabled="!isSubscribed && !!transactions[i - 1]">
                    <template v-slot:activator="{ on, attrs }">
                      <div class="transaction mr-2" :class="{ active: transactions[i] }" v-bind="attrs"
                        v-on="on"></div>
                    </template>
                    <span>{{transactions[i] ? $t('settings.management.successfulPayment') : isSubscribed ? $t('settings.management.waitingPayment') : $t('settings.management.errorPayment') }}</span>
                  </v-tooltip>
                </span>
            </div>
            <div v-if="!isSpecial && !isHotmartSubscription" @click="cancelDialog = true" class="action mt-2 mt-sm-0 mb-n1">{{ $t('settings.management.cancelSubscription') }}</div>
          </div>
        </v-col>
      </v-row>

      <v-row v-if="!isHotmartSubscription" class="mx-2 mx-sm-10 d-block d-sm-flex">
        <v-col cols="3" class="label d-flex align-center justify-center justify-sm-end mb-n3 mb-sm-0">
          {{ $t('settings.management.paymentMethod') }}
        </v-col>
        <v-col>
          <div class="box px-4 pt-5 pb-4 rounded">
            <div class="d-block d-sm-flex text-center justify-space-between  align-center ">
              <div v-if="subscription.paymentMethods[0]" class="d-flex align-center justify-center text">
                <component :is="`iconCard${subscription.paymentMethods[0].brand.replace(' ', '')}`" height="18" class="mr-1"></component>
                <div>{{subscription.paymentMethods[0].brand}} ****{{subscription.paymentMethods[0].last4}}</div>
              </div>
              <div class="action mt-2 mt-sm-0 mb-n1" @click="showCardForm = !showCardForm">
                {{showCardForm ? $t('settings.management.cancel') : $t('settings.management.update')}}
                </div>
            </div>
            <cardForm v-if="showCardForm" @submit="changePaymentMethod" buttonLabel="Update" class="mt-4" style="max-width: 300px;" />
          </div>
        </v-col>
      </v-row>

      <v-row v-if="(!isSpecial || is3xLifetime) && !isHotmartSubscription" class="mx-2 mx-sm-10 d-block d-sm-flex">
        <v-col cols="3" class="label d-flex align-center justify-center justify-sm-end mb-n3 mb-sm-0">
          {{ $t('settings.management.nextPayment') }}
        </v-col>
        <v-col>
          <div class="box px-4 pt-3 pb-2 d-flex flex-column rounded text-center text-sm-left">
            <div class="text">
              {{endDate}} ${{subscription.plan.amount / 100}} USD
            </div>
            <div class="text">
              {{subscription.plan.productName}} InputU Plus
            </div>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-dialog
      v-model="cancelDialog"
      max-width="280"
      class="main_page_settings"
    >
      <v-card>
        <cancelModal @close="cancelDialog = false"/>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import toastr from '@/plugins/toastr';
import iconCardAmericanExpress from '@/static/custom-img/logo/amex.svg';
import loaderButton from '@/components/base/loaderButton';
import cancelModal from '@/components/settings/cancelModal';
// eslint-disable-next-line camelcase
import iconCardDinersClub from '@/static/custom-img/logo/diners.svg';
import iconCardDiscover from '@/static/custom-img/logo/discover.svg';
import iconCardJCB from '@/static/custom-img/logo/jcb.svg';
import iconCardMasterCard from '@/static/custom-img/logo/mastercard.svg';
import iconCardUnionPay from '@/static/custom-img/logo/unionpay.svg';
import iconCardVisa from '@/static/custom-img/logo/visa.svg';
// import iconLogoPlus from '@/static/img/logo-plus.svg';
import iconInfo from '@/static/custom-img/info.svg';
import iconNext from '@/static/custom-img/next.svg';

import cardForm from '@/components/subscription/cardForm';

export default {
  name: 'subscriptionManagement',

  data () {
    return {
      cancelDialog: false,
      showCardForm: false,
      restoreLoading: false,
    };
  },

  components: {
    iconCardAmericanExpress,
    iconCardDinersClub,
    iconCardDiscover,
    iconCardJCB,
    iconCardMasterCard,
    iconCardUnionPay,
    iconCardVisa,
    // iconLogoPlus,
    iconInfo,
    iconNext,
    cardForm,
    loaderButton,
    cancelModal,
  },

  computed: {
    user () {
      return this.$store.state.user.data.data;
    },

    subscription () {
      return this.user.subscription;
    },

    endDate () {
      const dt = new Date(this.subscription.endDate);
      const options = { year: 'numeric', month: 'long', day: 'numeric' };

      return dt.toLocaleDateString('en-US', options);
    },

    isSubscribed () {
      return this.user.isSubscribed && this.user.subscription;
    },

    isSpecial () {
      return this.$store.getters['user/isSpecial'];
    },

    is3xLifetime () {
      return this.isSpecial && this.subscription.plan.amount === 4999 && this.transactions.length < 3;
    },

    transactions () {
      return this.subscription.special.transactions;
    },

    isHotmartSubscription () {
      return this.subscription.appType === 'hotmart';
    },

    isWebSubscription () {
      return this.subscription.appType === 'web';
    },

    isIosSubscripton () {
      return this.subscription.appType === 'ios';
    },

    isCanceled () {
      return this.subscription.isRefunded;
    },

  },

  methods: {
    async changePaymentMethod ({ token }) {
      await this.$store.dispatch('user/UPDATE_PAYMENT_METHOD', token);
      this.showCardForm = false;
      toastr.success(this.$t('base.success'));
    },

    goToSubscribe () {
      this.$router.push({ name: 'subscription' });
    },

    async restore () {
      this.restoreLoading = true;
      await this.$store.dispatch({
        type: 'user/PURCHASE_RESTORE',
      });
      this.restoreLoading = false;
    },
  },
};
</script>

<style lang="scss">
[lang='ru'] {
  .pluses {
    text-transform: none!important;
  }
}
</style>

<style lang="scss" scoped>
.subscription {
  background-color: #F5F5F7;
  background-image: url('~@/static/custom-img/subscription_bg.png');
  background-position: center;
  background-size: contain;
}

.box {
  border: 1px solid #E5E5E5;
}

.start-trial {
  &::v-deep{
    span {
      white-space: pre-line;
      width: 100%;
    }
  }
}

.label {
  font-weight: bold;
font-size: 14px;
line-height: 20px;
/* identical to box height, or 143% */

text-align: right;
letter-spacing: 0.2px;

/* Text / Gray */

color: #44445E;
text-transform: capitalize;
}

.action {
  font-weight: 600;
font-size: 10px;
line-height: 20px;
/* or 200% */

letter-spacing: 0.2px;
text-transform: uppercase;

/* Pinky */

color: #FA507B;
cursor: pointer;
}

.text {
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */

  letter-spacing: 0.2px;

  /* Text / Gray */

  color: #44445E;

  &-canceled {
    font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  /* identical to box height */

  letter-spacing: 0.2px;

  color: #3736A0;
  }
}

.instruction {
  width: 360px;

  .next {
    margin-top: 60px;
  }

  .step-1 {
      width: 94px;

      .screenshot {
        height: 137px;
        background-image: url('~@/static/custom-img/step1-android.png');
        background-position: center;
        background-size: contain;
      }
  }
  .step-2 {
      width: 94px;

      .screenshot {
        height: 137px;
        background-image: url('~@/static/custom-img/step2-android.png');
        background-position: center;
        background-size: contain;
      }
  }
  .step-3 {
      width: 94px;

      .screenshot {
        height: 137px;
        background-image: url('~@/static/custom-img/step3-android.png');
        background-position: center;
        background-size: contain;
      }
  }

  &.ios {
    .step-1 {
        .screenshot {
          background-image: url('~@/static/custom-img/step1-ios.png');
        }
    }

    .step-2 {
        .screenshot {
          background-image: url('~@/static/custom-img/step2-ios.png');
        }
    }

    .step-3 {
        .screenshot {
          background-image: url('~@/static/custom-img/step3-ios.png');
        }
    }
  }
}

.pluses {
  max-width: 260px;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.2px;
  text-transform: capitalize;
}

.transaction {
  width: 5px;
  height: 15px;
  background: gray;
  border-radius: 15px;

  &.active {
    background-color: #FA507B;
  }
}

  @media #{map-get($display-breakpoints, 'xs-only')} {
    .label {
      width: 100%;
      max-width: 100%;
    }

    .pluses {
      font-size: 10px;
      line-height: 18px;
      text-align: center;
    }

    .instruction {
      width: 100%;
      text-align: center;

      .next {
        transform: rotate(90deg);
        margin-top: 5px;
      }

      .step-1,
      .step-2,
      .step-3 {
        margin: auto;
      }

    }
  }
</style>
